export class User{
    FullName: string;
    Id: string;
    OldIdentifier: string;
    CompanyId: string;
    Category: string;
    UserEmail: string;
    IsMember: boolean;
    constructor(
        fullName: string,
        id: string,
        oldIdentifier: string,
        companyId: string,
        category: string,
        userEmail: string,
        isMember: boolean
    ) {
        this.FullName = fullName;
        this.Id = id;
        this.OldIdentifier = oldIdentifier;
        this.CompanyId = companyId;
        this.Category = category;
        this.UserEmail = userEmail;
        this.IsMember = isMember;
    }
}